module.exports = __webpack_public_path__ + "assets/93ab8115830bb01b20309c748a2d6da1.mp3";